// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"1eaf6960","942":"e62b3f73"}[chunkId] + ".chunk.js";
};